// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__mDOhc","title":"Card_title__BypO9","year":"Card_year__bc-Ba","Avatar":"Card_Avatar__2dZog"};